import { render, staticRenderFns } from "./CaseOverviewHolder.vue?vue&type=template&id=71045cca"
import script from "./CaseOverviewHolder.vue?vue&type=script&lang=js"
export * from "./CaseOverviewHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports